import { render, staticRenderFns } from "./SucursalCard.vue?vue&type=template&id=86882d58"
import script from "./SucursalCard.vue?vue&type=script&lang=js"
export * from "./SucursalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports